import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestZantacLawyersWrapper from "@components/layouts/bestzantaclawyersWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function BestZantacLawyersHome(): ReactElement {
    return (
        <BestZantacLawyersWrapper>
            <div className="w-full max-w-7xl mx-auto">
                <PrivacyPolicy
                    category="Zantac"
                    domain="BestZantacLawyers.com"
                />
            </div>
        </BestZantacLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
